module.exports = __webpack_public_path__ + "img/amx-10.1feace25.jpg";